﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ActivityCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: ActivityDto_LoadAll | null | undefined): Observable<PagedResultDtoOfActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfActivityDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param currentDay (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @param timeType (optional) 
     * @param stTime (optional) 
     * @param edTime (optional) 
     * @return Success
     */
    getAllByAnonymous(currentDay: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined, timeType: number | null | undefined, stTime: moment.Moment | null | undefined, edTime: moment.Moment | null | undefined): Observable<PagedResultDtoOfActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/GetAllByAnonymous?";
        if (currentDay !== undefined)
            url_ += "CurrentDay=" + encodeURIComponent("" + currentDay) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (timeType !== undefined)
            url_ += "timeType=" + encodeURIComponent("" + timeType) + "&"; 
        if (stTime !== undefined)
            url_ += "stTime=" + encodeURIComponent(stTime ? "" + stTime.toJSON() : "") + "&"; 
        if (edTime !== undefined)
            url_ += "edTime=" + encodeURIComponent(edTime ? "" + edTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAnonymous(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByAnonymous(response: HttpResponseBase): Observable<PagedResultDtoOfActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfActivityDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    postCurrent(input: ActivityDto_TakeCurrent | null | undefined): Observable<PagedResultDtoOfActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/PostCurrent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCurrent(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processPostCurrent(response: HttpResponseBase): Observable<PagedResultDtoOfActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfActivityDto.fromJS(resultData200) : new PagedResultDtoOfActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActivityDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityDto_WithRelation.fromJS(resultData200) : new ActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param timeType (optional) 
     * @param stTime (optional) 
     * @param edTime (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, timeType: number | null | undefined, stTime: moment.Moment | null | undefined, edTime: moment.Moment | null | undefined): Observable<PagedResultDtoOfActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/GetAll?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (timeType !== undefined)
            url_ += "timeType=" + encodeURIComponent("" + timeType) + "&"; 
        if (stTime !== undefined)
            url_ += "stTime=" + encodeURIComponent(stTime ? "" + stTime.toJSON() : "") + "&"; 
        if (edTime !== undefined)
            url_ += "edTime=" + encodeURIComponent(edTime ? "" + edTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfActivityDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: ActivityDto_Create | null | undefined): Observable<ActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityDto_WithRelation.fromJS(resultData200) : new ActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ActivityDto_Update | null | undefined): Observable<ActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityDto_WithRelation.fromJS(resultData200) : new ActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ArticleCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: ArticleDto_Create | null | undefined): Observable<ArticleDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ArticleDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<ArticleDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ArticleDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArticleDto_WithRelation.fromJS(resultData200) : new ArticleDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticleDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ArticleDto_Update | null | undefined): Observable<ArticleDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ArticleDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<ArticleDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ArticleDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArticleDto_WithRelation.fromJS(resultData200) : new ArticleDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticleDto_WithRelation>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: ArticleDto_LoadAll | null | undefined): Observable<PagedResultDtoOfArticleDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfArticleDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfArticleDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfArticleDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfArticleDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfArticleDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfArticleDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ArticleDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ArticleDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<ArticleDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ArticleDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArticleDto_WithRelation.fromJS(resultData200) : new ArticleDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticleDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfArticleDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfArticleDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfArticleDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfArticleDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfArticleDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfArticleDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfArticleDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NewsCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param newsTypeID (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllByTypeID(newsTypeID: number | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/GetAllByTypeID?";
        if (newsTypeID !== undefined)
            url_ += "NewsTypeID=" + encodeURIComponent("" + newsTypeID) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByTypeID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByTypeID(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByTypeID(response: HttpResponseBase): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfNewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsDto_WithRelation>(<any>null);
    }

    /**
     * @param newsTypeID (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAnonymous(newsTypeID: number | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/GetAllAnonymous?";
        if (newsTypeID !== undefined)
            url_ += "NewsTypeID=" + encodeURIComponent("" + newsTypeID) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAnonymous(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAnonymous(response: HttpResponseBase): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfNewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    postCurrent(input: NewsDto_TakeCurrent | null | undefined): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/PostCurrent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCurrent(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processPostCurrent(response: HttpResponseBase): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfNewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: NewsDto_Create | null | undefined): Observable<NewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<NewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsDto_WithRelation.fromJS(resultData200) : new NewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsDto_WithRelation>(<any>null);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    deleteAll(inputs: NewsDto_Delete[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: NewsDto_LoadAll | null | undefined): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfNewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<NewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<NewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsDto_WithRelation.fromJS(resultData200) : new NewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfNewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfNewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: NewsDto_Update | null | undefined): Observable<NewsDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<NewsDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NewsDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsDto_WithRelation.fromJS(resultData200) : new NewsDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NewsCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NewsTypeCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: NewsTypeDto_LoadAll | null | undefined): Observable<PagedResultDtoOfNewsTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfNewsTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsTypeDto.fromJS(resultData200) : new PagedResultDtoOfNewsTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsTypeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<NewsTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<NewsTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NewsTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsTypeDto.fromJS(resultData200) : new NewsTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfNewsTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfNewsTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNewsTypeDto.fromJS(resultData200) : new PagedResultDtoOfNewsTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: NewsTypeDto_Create | null | undefined): Observable<NewsTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<NewsTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NewsTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsTypeDto.fromJS(resultData200) : new NewsTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: NewsTypeDto_Update | null | undefined): Observable<NewsTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<NewsTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NewsTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsTypeDto.fromJS(resultData200) : new NewsTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsTypeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NewsTypeCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTreeItems(id: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfTreeItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Tree/GetTreeItems?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTreeItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTreeItems(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTreeItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTreeItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTreeItems(response: HttpResponseBase): Observable<PagedResultDtoOfTreeItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTreeItemDto.fromJS(resultData200) : new PagedResultDtoOfTreeItemDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTreeItemDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTrees(): Observable<ListResultDtoOfTreeDto> {
        let url_ = this.baseUrl + "/api/services/app/Tree/GetTrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrees(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTreeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfTreeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTrees(response: HttpResponseBase): Observable<ListResultDtoOfTreeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTreeDto.fromJS(resultData200) : new ListResultDtoOfTreeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfTreeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createTree(input: CreateTreeInput | null | undefined): Observable<TreeDto> {
        let url_ = this.baseUrl + "/api/services/app/Tree/CreateTree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTree(<any>response_);
                } catch (e) {
                    return <Observable<TreeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTree(response: HttpResponseBase): Observable<TreeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeDto.fromJS(resultData200) : new TreeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateTree(input: UpdateTreeInput | null | undefined): Observable<TreeDto> {
        let url_ = this.baseUrl + "/api/services/app/Tree/UpdateTree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTree(<any>response_);
                } catch (e) {
                    return <Observable<TreeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTree(response: HttpResponseBase): Observable<TreeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeDto.fromJS(resultData200) : new TreeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTree(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tree/DeleteTree?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTree(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTree(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    moveTree(input: MoveTreeInput | null | undefined): Observable<TreeDto> {
        let url_ = this.baseUrl + "/api/services/app/Tree/MoveTree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTree(<any>response_);
                } catch (e) {
                    return <Observable<TreeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeDto>><any>_observableThrow(response_);
        }));
    }

    protected processMoveTree(response: HttpResponseBase): Observable<TreeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeDto.fromJS(resultData200) : new TreeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeDto>(<any>null);
    }
}

@Injectable()
export class TreeCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: TreeDto_LoadAll | null | undefined): Observable<PagedResultDtoOfTreeDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTreeDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTreeDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfTreeDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTreeDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfTreeDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTreeDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TreeDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreeDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreeDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeDto_WithRelation.fromJS(resultData200) : new TreeDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfTreeDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTreeDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTreeDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTreeDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTreeDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfTreeDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTreeDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: TreeDto_Create | null | undefined): Observable<TreeDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TreeDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TreeDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeDto_WithRelation.fromJS(resultData200) : new TreeDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TreeDto_Update | null | undefined): Observable<TreeDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TreeDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TreeDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeDto_WithRelation.fromJS(resultData200) : new TreeDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TreeItemCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: TreeItemDto_LoadAll | null | undefined): Observable<PagedResultDtoOfTreeItemDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTreeItemDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTreeItemDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfTreeItemDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTreeItemDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfTreeItemDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTreeItemDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TreeItemDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TreeItemDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeItemDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreeItemDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeItemDto_WithRelation.fromJS(resultData200) : new TreeItemDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeItemDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfTreeItemDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTreeItemDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTreeItemDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTreeItemDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTreeItemDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfTreeItemDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTreeItemDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: TreeItemDto_Create | null | undefined): Observable<TreeItemDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TreeItemDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeItemDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TreeItemDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeItemDto_WithRelation.fromJS(resultData200) : new TreeItemDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeItemDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TreeItemDto_Update | null | undefined): Observable<TreeItemDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TreeItemDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeItemDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TreeItemDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TreeItemDto_WithRelation.fromJS(resultData200) : new TreeItemDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeItemDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TreeItemCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    uploadTreeFile(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Upload/UploadTreeFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTreeFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTreeFile(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processUploadTreeFile(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param urls (optional) 
     * @return Success
     */
    deleteTreeFiles(urls: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Upload/DeleteTreeFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urls);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTreeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTreeFiles(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTreeFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteTreeDirectory(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Upload/DeleteTreeDirectory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTreeDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTreeDirectory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTreeDirectory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    uploadNewsFile(id: number | null | undefined): Observable<NewsDto_Update> {
        let url_ = this.baseUrl + "/api/Upload/UploadNewsFile?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewsFile(<any>response_);
                } catch (e) {
                    return <Observable<NewsDto_Update>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsDto_Update>><any>_observableThrow(response_);
        }));
    }

    protected processUploadNewsFile(response: HttpResponseBase): Observable<NewsDto_Update> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewsDto_Update.fromJS(resultData200) : new NewsDto_Update();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsDto_Update>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param fileNames (optional) 
     * @return Success
     */
    deleteNewsFile(id: number | null | undefined, fileNames: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Upload/DeleteNewsFile?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (fileNames !== undefined)
            fileNames && fileNames.forEach(item => { url_ += "FileNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNewsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNewsFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNewsFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activityFile(id: number | null | undefined): Observable<ActivityDto_Update> {
        let url_ = this.baseUrl + "/api/Upload/ActivityFile?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivityFile(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto_Update>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto_Update>><any>_observableThrow(response_);
        }));
    }

    protected processActivityFile(response: HttpResponseBase): Observable<ActivityDto_Update> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityDto_Update.fromJS(resultData200) : new ActivityDto_Update();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto_Update>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    clearActivityFile(id: number | null | undefined): Observable<ActivityDto_Update> {
        let url_ = this.baseUrl + "/api/Upload/ClearActivityFile?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearActivityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearActivityFile(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto_Update>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto_Update>><any>_observableThrow(response_);
        }));
    }

    protected processClearActivityFile(response: HttpResponseBase): Observable<ActivityDto_Update> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityDto_Update.fromJS(resultData200) : new ActivityDto_Update();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto_Update>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    postUploadImage(input: ActivityDto_ImageUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Upload/PostUploadImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPostUploadImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserActivityCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param activityId (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    getAllByActivityId(activityId: number | null | undefined, keyword: string | null | undefined): Observable<UserActivityDto_WithRelation[]> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/GetAllByActivityId?";
        if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByActivityId(<any>response_);
                } catch (e) {
                    return <Observable<UserActivityDto_WithRelation[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActivityDto_WithRelation[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByActivityId(response: HttpResponseBase): Observable<UserActivityDto_WithRelation[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserActivityDto_WithRelation.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActivityDto_WithRelation[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createByIds(input: UserActivityDto_CreateByIds | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/CreateByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    findActivityUser(input: UserActivityDto_FindActivityUserInput | null | undefined): Observable<PagedResultDtoOfUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/FindActivityUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindActivityUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindActivityUser(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindActivityUser(response: HttpResponseBase): Observable<PagedResultDtoOfUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserDto.fromJS(resultData200) : new PagedResultDtoOfUserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAllByUserId(input: UserActivityDto_LoadAllByUserId | null | undefined): Observable<PagedResultDtoOfUserActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/LoadAllByUserId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllByUserId(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllByUserId(response: HttpResponseBase): Observable<PagedResultDtoOfUserActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserActivityDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfUserActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: UserActivityDto_LoadAll | null | undefined): Observable<PagedResultDtoOfUserActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserActivityDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfUserActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserActivityDto_WithRelation.fromJS(resultData200) : new UserActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfUserActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserActivityDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfUserActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: UserActivityDto_Create | null | undefined): Observable<UserActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserActivityDto_WithRelation.fromJS(resultData200) : new UserActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserActivityDto_Update | null | undefined): Observable<UserActivityDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserActivityDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActivityDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserActivityDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserActivityDto_WithRelation.fromJS(resultData200) : new UserActivityDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActivityDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class ActivityDto_LoadAll implements IActivityDto_LoadAll {
    keyword: string | undefined;
    timeType: number | undefined;
    stTime: moment.Moment | undefined;
    edTime: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IActivityDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyword = data["keyword"];
            this.timeType = data["timeType"];
            this.stTime = data["stTime"] ? moment(data["stTime"].toString()) : <any>undefined;
            this.edTime = data["edTime"] ? moment(data["edTime"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): ActivityDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["timeType"] = this.timeType;
        data["stTime"] = this.stTime ? this.stTime.toISOString() : <any>undefined;
        data["edTime"] = this.edTime ? this.edTime.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): ActivityDto_LoadAll {
        const json = this.toJSON();
        let result = new ActivityDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IActivityDto_LoadAll {
    keyword: string | undefined;
    timeType: number | undefined;
    stTime: moment.Moment | undefined;
    edTime: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfActivityDto_WithRelation implements IPagedResultDtoOfActivityDto_WithRelation {
    totalCount: number | undefined;
    items: ActivityDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfActivityDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ActivityDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivityDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActivityDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfActivityDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfActivityDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfActivityDto_WithRelation {
    totalCount: number | undefined;
    items: ActivityDto_WithRelation[] | undefined;
}

export class ActivityDto_WithRelation implements IActivityDto_WithRelation {
    userActivities: UserActivityDto[] | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;

    constructor(data?: IActivityDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userActivities"] && data["userActivities"].constructor === Array) {
                this.userActivities = [] as any;
                for (let item of data["userActivities"])
                    this.userActivities.push(UserActivityDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.isOpen = data["isOpen"];
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.applyStartTime = data["applyStartTime"] ? moment(data["applyStartTime"].toString()) : <any>undefined;
            this.applyEndTime = data["applyEndTime"] ? moment(data["applyEndTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.place = data["place"];
            this.fileFields = data["fileFields"] ? FileFields.fromJS(data["fileFields"]) : <any>undefined;
            this.imageFields = data["imageFields"] ? ImageFields.fromJS(data["imageFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userActivities && this.userActivities.constructor === Array) {
            data["userActivities"] = [];
            for (let item of this.userActivities)
                data["userActivities"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["isOpen"] = this.isOpen;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["applyStartTime"] = this.applyStartTime ? this.applyStartTime.toISOString() : <any>undefined;
        data["applyEndTime"] = this.applyEndTime ? this.applyEndTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["place"] = this.place;
        data["fileFields"] = this.fileFields ? this.fileFields.toJSON() : <any>undefined;
        data["imageFields"] = this.imageFields ? this.imageFields.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivityDto_WithRelation {
        const json = this.toJSON();
        let result = new ActivityDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IActivityDto_WithRelation {
    userActivities: UserActivityDto[] | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;
}

export class UserActivityDto implements IUserActivityDto {
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;

    constructor(data?: IUserActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.activityId = data["activityId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UserActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): UserActivityDto {
        const json = this.toJSON();
        let result = new UserActivityDto();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto {
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;
}

export class FullAuditedDto implements IFullAuditedDto {
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean | undefined;

    constructor(data?: IFullAuditedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
        }
    }

    static fromJS(data: any): FullAuditedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullAuditedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): FullAuditedDto {
        const json = this.toJSON();
        let result = new FullAuditedDto();
        result.init(json);
        return result;
    }
}

export interface IFullAuditedDto {
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean | undefined;
}

export class FileFields implements IFileFields {
    title: string | undefined;
    url: string | undefined;
    size: string | undefined;
    fileType: string | undefined;

    constructor(data?: IFileFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.url = data["url"];
            this.size = data["size"];
            this.fileType = data["fileType"];
        }
    }

    static fromJS(data: any): FileFields {
        data = typeof data === 'object' ? data : {};
        let result = new FileFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["size"] = this.size;
        data["fileType"] = this.fileType;
        return data; 
    }

    clone(): FileFields {
        const json = this.toJSON();
        let result = new FileFields();
        result.init(json);
        return result;
    }
}

export interface IFileFields {
    title: string | undefined;
    url: string | undefined;
    size: string | undefined;
    fileType: string | undefined;
}

export class ImageFields implements IImageFields {
    title: string | undefined;
    url: string | undefined;
    width: number | undefined;
    height: number | undefined;
    isCover: boolean | undefined;

    constructor(data?: IImageFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.url = data["url"];
            this.width = data["width"];
            this.height = data["height"];
            this.isCover = data["isCover"];
        }
    }

    static fromJS(data: any): ImageFields {
        data = typeof data === 'object' ? data : {};
        let result = new ImageFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["width"] = this.width;
        data["height"] = this.height;
        data["isCover"] = this.isCover;
        return data; 
    }

    clone(): ImageFields {
        const json = this.toJSON();
        let result = new ImageFields();
        result.init(json);
        return result;
    }
}

export interface IImageFields {
    title: string | undefined;
    url: string | undefined;
    width: number | undefined;
    height: number | undefined;
    isCover: boolean | undefined;
}

export class ActivityDto_TakeCurrent implements IActivityDto_TakeCurrent {
    takeCount: number | undefined;

    constructor(data?: IActivityDto_TakeCurrent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.takeCount = data["takeCount"];
        }
    }

    static fromJS(data: any): ActivityDto_TakeCurrent {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto_TakeCurrent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["takeCount"] = this.takeCount;
        return data; 
    }

    clone(): ActivityDto_TakeCurrent {
        const json = this.toJSON();
        let result = new ActivityDto_TakeCurrent();
        result.init(json);
        return result;
    }
}

export interface IActivityDto_TakeCurrent {
    takeCount: number | undefined;
}

export class PagedResultDtoOfActivityDto implements IPagedResultDtoOfActivityDto {
    totalCount: number | undefined;
    items: ActivityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfActivityDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfActivityDto {
    totalCount: number | undefined;
    items: ActivityDto[] | undefined;
}

export class ActivityDto implements IActivityDto {
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isOpen = data["isOpen"];
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.applyStartTime = data["applyStartTime"] ? moment(data["applyStartTime"].toString()) : <any>undefined;
            this.applyEndTime = data["applyEndTime"] ? moment(data["applyEndTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.place = data["place"];
            this.fileFields = data["fileFields"] ? FileFields.fromJS(data["fileFields"]) : <any>undefined;
            this.imageFields = data["imageFields"] ? ImageFields.fromJS(data["imageFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOpen"] = this.isOpen;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["applyStartTime"] = this.applyStartTime ? this.applyStartTime.toISOString() : <any>undefined;
        data["applyEndTime"] = this.applyEndTime ? this.applyEndTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["place"] = this.place;
        data["fileFields"] = this.fileFields ? this.fileFields.toJSON() : <any>undefined;
        data["imageFields"] = this.imageFields ? this.imageFields.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDto {
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;
}

export class ActivityDto_Create implements IActivityDto_Create {
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;

    constructor(data?: IActivityDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isOpen = data["isOpen"];
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.applyStartTime = data["applyStartTime"] ? moment(data["applyStartTime"].toString()) : <any>undefined;
            this.applyEndTime = data["applyEndTime"] ? moment(data["applyEndTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.place = data["place"];
            this.fileFields = data["fileFields"] ? FileFields.fromJS(data["fileFields"]) : <any>undefined;
            this.imageFields = data["imageFields"] ? ImageFields.fromJS(data["imageFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOpen"] = this.isOpen;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["applyStartTime"] = this.applyStartTime ? this.applyStartTime.toISOString() : <any>undefined;
        data["applyEndTime"] = this.applyEndTime ? this.applyEndTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["place"] = this.place;
        data["fileFields"] = this.fileFields ? this.fileFields.toJSON() : <any>undefined;
        data["imageFields"] = this.imageFields ? this.imageFields.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivityDto_Create {
        const json = this.toJSON();
        let result = new ActivityDto_Create();
        result.init(json);
        return result;
    }
}

export interface IActivityDto_Create {
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;
}

export class ActivityDto_Update implements IActivityDto_Update {
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;

    constructor(data?: IActivityDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isOpen = data["isOpen"];
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.applyStartTime = data["applyStartTime"] ? moment(data["applyStartTime"].toString()) : <any>undefined;
            this.applyEndTime = data["applyEndTime"] ? moment(data["applyEndTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.place = data["place"];
            this.fileFields = data["fileFields"] ? FileFields.fromJS(data["fileFields"]) : <any>undefined;
            this.imageFields = data["imageFields"] ? ImageFields.fromJS(data["imageFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOpen"] = this.isOpen;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["applyStartTime"] = this.applyStartTime ? this.applyStartTime.toISOString() : <any>undefined;
        data["applyEndTime"] = this.applyEndTime ? this.applyEndTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["place"] = this.place;
        data["fileFields"] = this.fileFields ? this.fileFields.toJSON() : <any>undefined;
        data["imageFields"] = this.imageFields ? this.imageFields.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivityDto_Update {
        const json = this.toJSON();
        let result = new ActivityDto_Update();
        result.init(json);
        return result;
    }
}

export interface IActivityDto_Update {
    id: number | undefined;
    isOpen: boolean | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    applyStartTime: moment.Moment | undefined;
    applyEndTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    place: string | undefined;
    fileFields: FileFields | undefined;
    imageFields: ImageFields | undefined;
}

export class ArticleDto_Create implements IArticleDto_Create {
    id: number | undefined;
    code: string | undefined;
    title: string | undefined;
    content: string | undefined;

    constructor(data?: IArticleDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.title = data["title"];
            this.content = data["content"];
        }
    }

    static fromJS(data: any): ArticleDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["content"] = this.content;
        return data; 
    }

    clone(): ArticleDto_Create {
        const json = this.toJSON();
        let result = new ArticleDto_Create();
        result.init(json);
        return result;
    }
}

export interface IArticleDto_Create {
    id: number | undefined;
    code: string | undefined;
    title: string | undefined;
    content: string | undefined;
}

export class ArticleDto_WithRelation implements IArticleDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    code: string | undefined;
    title: string | undefined;
    content: string | undefined;

    constructor(data?: IArticleDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.code = data["code"];
            this.title = data["title"];
            this.content = data["content"];
        }
    }

    static fromJS(data: any): ArticleDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["content"] = this.content;
        return data; 
    }

    clone(): ArticleDto_WithRelation {
        const json = this.toJSON();
        let result = new ArticleDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IArticleDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    code: string | undefined;
    title: string | undefined;
    content: string | undefined;
}

export class ArticleDto_Update implements IArticleDto_Update {
    id: number | undefined;
    code: string | undefined;
    title: string | undefined;
    content: string | undefined;

    constructor(data?: IArticleDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.title = data["title"];
            this.content = data["content"];
        }
    }

    static fromJS(data: any): ArticleDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["content"] = this.content;
        return data; 
    }

    clone(): ArticleDto_Update {
        const json = this.toJSON();
        let result = new ArticleDto_Update();
        result.init(json);
        return result;
    }
}

export interface IArticleDto_Update {
    id: number | undefined;
    code: string | undefined;
    title: string | undefined;
    content: string | undefined;
}

export class ArticleDto_LoadAll implements IArticleDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IArticleDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): ArticleDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): ArticleDto_LoadAll {
        const json = this.toJSON();
        let result = new ArticleDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IArticleDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfArticleDto_WithRelation implements IPagedResultDtoOfArticleDto_WithRelation {
    totalCount: number | undefined;
    items: ArticleDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfArticleDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ArticleDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfArticleDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfArticleDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfArticleDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfArticleDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfArticleDto_WithRelation {
    totalCount: number | undefined;
    items: ArticleDto_WithRelation[] | undefined;
}

export class PagedResultDtoOfNewsDto_WithRelation implements IPagedResultDtoOfNewsDto_WithRelation {
    totalCount: number | undefined;
    items: NewsDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfNewsDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(NewsDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNewsDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNewsDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfNewsDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNewsDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNewsDto_WithRelation {
    totalCount: number | undefined;
    items: NewsDto_WithRelation[] | undefined;
}

export class NewsDto_WithRelation implements INewsDto_WithRelation {
    newsType: NewsTypeDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    title: string | undefined;
    linkUrl: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    displayMode: NewsDto_WithRelationDisplayMode | undefined;
    published: boolean | undefined;
    published_By: string | undefined;
    published_At: moment.Moment | undefined;
    newsTypeId: number | undefined;
    fileFields: FileFields[] | undefined;
    imagesFields: ImageFields[] | undefined;

    constructor(data?: INewsDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newsType = data["newsType"] ? NewsTypeDto.fromJS(data["newsType"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.title = data["title"];
            this.linkUrl = data["linkUrl"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.displayMode = data["displayMode"];
            this.published = data["published"];
            this.published_By = data["published_By"];
            this.published_At = data["published_At"] ? moment(data["published_At"].toString()) : <any>undefined;
            this.newsTypeId = data["newsTypeId"];
            if (data["fileFields"] && data["fileFields"].constructor === Array) {
                this.fileFields = [] as any;
                for (let item of data["fileFields"])
                    this.fileFields.push(FileFields.fromJS(item));
            }
            if (data["imagesFields"] && data["imagesFields"].constructor === Array) {
                this.imagesFields = [] as any;
                for (let item of data["imagesFields"])
                    this.imagesFields.push(ImageFields.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsType"] = this.newsType ? this.newsType.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["title"] = this.title;
        data["linkUrl"] = this.linkUrl;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["displayMode"] = this.displayMode;
        data["published"] = this.published;
        data["published_By"] = this.published_By;
        data["published_At"] = this.published_At ? this.published_At.toISOString() : <any>undefined;
        data["newsTypeId"] = this.newsTypeId;
        if (this.fileFields && this.fileFields.constructor === Array) {
            data["fileFields"] = [];
            for (let item of this.fileFields)
                data["fileFields"].push(item.toJSON());
        }
        if (this.imagesFields && this.imagesFields.constructor === Array) {
            data["imagesFields"] = [];
            for (let item of this.imagesFields)
                data["imagesFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NewsDto_WithRelation {
        const json = this.toJSON();
        let result = new NewsDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface INewsDto_WithRelation {
    newsType: NewsTypeDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    title: string | undefined;
    linkUrl: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    displayMode: NewsDto_WithRelationDisplayMode | undefined;
    published: boolean | undefined;
    published_By: string | undefined;
    published_At: moment.Moment | undefined;
    newsTypeId: number | undefined;
    fileFields: FileFields[] | undefined;
    imagesFields: ImageFields[] | undefined;
}

export class NewsTypeDto implements INewsTypeDto {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;

    constructor(data?: INewsTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
        }
    }

    static fromJS(data: any): NewsTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data; 
    }

    clone(): NewsTypeDto {
        const json = this.toJSON();
        let result = new NewsTypeDto();
        result.init(json);
        return result;
    }
}

export interface INewsTypeDto {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
}

export class NewsDto_TakeCurrent implements INewsDto_TakeCurrent {
    takeCount: number | undefined;

    constructor(data?: INewsDto_TakeCurrent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.takeCount = data["takeCount"];
        }
    }

    static fromJS(data: any): NewsDto_TakeCurrent {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto_TakeCurrent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["takeCount"] = this.takeCount;
        return data; 
    }

    clone(): NewsDto_TakeCurrent {
        const json = this.toJSON();
        let result = new NewsDto_TakeCurrent();
        result.init(json);
        return result;
    }
}

export interface INewsDto_TakeCurrent {
    takeCount: number | undefined;
}

export class NewsDto_Create implements INewsDto_Create {
    id: number | undefined;
    title: string | undefined;
    linkUrl: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    displayMode: NewsDto_CreateDisplayMode | undefined;
    published: boolean | undefined;
    published_By: string | undefined;
    published_At: moment.Moment | undefined;
    newsTypeId: number | undefined;
    fileFields: FileFields[] | undefined;
    imagesFields: ImageFields[] | undefined;

    constructor(data?: INewsDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.linkUrl = data["linkUrl"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.displayMode = data["displayMode"];
            this.published = data["published"];
            this.published_By = data["published_By"];
            this.published_At = data["published_At"] ? moment(data["published_At"].toString()) : <any>undefined;
            this.newsTypeId = data["newsTypeId"];
            if (data["fileFields"] && data["fileFields"].constructor === Array) {
                this.fileFields = [] as any;
                for (let item of data["fileFields"])
                    this.fileFields.push(FileFields.fromJS(item));
            }
            if (data["imagesFields"] && data["imagesFields"].constructor === Array) {
                this.imagesFields = [] as any;
                for (let item of data["imagesFields"])
                    this.imagesFields.push(ImageFields.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["linkUrl"] = this.linkUrl;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["displayMode"] = this.displayMode;
        data["published"] = this.published;
        data["published_By"] = this.published_By;
        data["published_At"] = this.published_At ? this.published_At.toISOString() : <any>undefined;
        data["newsTypeId"] = this.newsTypeId;
        if (this.fileFields && this.fileFields.constructor === Array) {
            data["fileFields"] = [];
            for (let item of this.fileFields)
                data["fileFields"].push(item.toJSON());
        }
        if (this.imagesFields && this.imagesFields.constructor === Array) {
            data["imagesFields"] = [];
            for (let item of this.imagesFields)
                data["imagesFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NewsDto_Create {
        const json = this.toJSON();
        let result = new NewsDto_Create();
        result.init(json);
        return result;
    }
}

export interface INewsDto_Create {
    id: number | undefined;
    title: string | undefined;
    linkUrl: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    displayMode: NewsDto_CreateDisplayMode | undefined;
    published: boolean | undefined;
    published_By: string | undefined;
    published_At: moment.Moment | undefined;
    newsTypeId: number | undefined;
    fileFields: FileFields[] | undefined;
    imagesFields: ImageFields[] | undefined;
}

export class NewsDto_Delete implements INewsDto_Delete {
    id: number | undefined;

    constructor(data?: INewsDto_Delete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NewsDto_Delete {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto_Delete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): NewsDto_Delete {
        const json = this.toJSON();
        let result = new NewsDto_Delete();
        result.init(json);
        return result;
    }
}

export interface INewsDto_Delete {
    id: number | undefined;
}

export class NewsDto_LoadAll implements INewsDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: INewsDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): NewsDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): NewsDto_LoadAll {
        const json = this.toJSON();
        let result = new NewsDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface INewsDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class NewsDto_Update implements INewsDto_Update {
    id: number | undefined;
    title: string | undefined;
    linkUrl: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    displayMode: NewsDto_UpdateDisplayMode | undefined;
    published: boolean | undefined;
    published_By: string | undefined;
    published_At: moment.Moment | undefined;
    newsTypeId: number | undefined;
    fileFields: FileFields[] | undefined;
    imagesFields: ImageFields[] | undefined;

    constructor(data?: INewsDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.linkUrl = data["linkUrl"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.displayMode = data["displayMode"];
            this.published = data["published"];
            this.published_By = data["published_By"];
            this.published_At = data["published_At"] ? moment(data["published_At"].toString()) : <any>undefined;
            this.newsTypeId = data["newsTypeId"];
            if (data["fileFields"] && data["fileFields"].constructor === Array) {
                this.fileFields = [] as any;
                for (let item of data["fileFields"])
                    this.fileFields.push(FileFields.fromJS(item));
            }
            if (data["imagesFields"] && data["imagesFields"].constructor === Array) {
                this.imagesFields = [] as any;
                for (let item of data["imagesFields"])
                    this.imagesFields.push(ImageFields.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["linkUrl"] = this.linkUrl;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["displayMode"] = this.displayMode;
        data["published"] = this.published;
        data["published_By"] = this.published_By;
        data["published_At"] = this.published_At ? this.published_At.toISOString() : <any>undefined;
        data["newsTypeId"] = this.newsTypeId;
        if (this.fileFields && this.fileFields.constructor === Array) {
            data["fileFields"] = [];
            for (let item of this.fileFields)
                data["fileFields"].push(item.toJSON());
        }
        if (this.imagesFields && this.imagesFields.constructor === Array) {
            data["imagesFields"] = [];
            for (let item of this.imagesFields)
                data["imagesFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NewsDto_Update {
        const json = this.toJSON();
        let result = new NewsDto_Update();
        result.init(json);
        return result;
    }
}

export interface INewsDto_Update {
    id: number | undefined;
    title: string | undefined;
    linkUrl: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    displayMode: NewsDto_UpdateDisplayMode | undefined;
    published: boolean | undefined;
    published_By: string | undefined;
    published_At: moment.Moment | undefined;
    newsTypeId: number | undefined;
    fileFields: FileFields[] | undefined;
    imagesFields: ImageFields[] | undefined;
}

export class NewsTypeDto_LoadAll implements INewsTypeDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: INewsTypeDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): NewsTypeDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new NewsTypeDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): NewsTypeDto_LoadAll {
        const json = this.toJSON();
        let result = new NewsTypeDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface INewsTypeDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfNewsTypeDto implements IPagedResultDtoOfNewsTypeDto {
    totalCount: number | undefined;
    items: NewsTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNewsTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(NewsTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNewsTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNewsTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfNewsTypeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNewsTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNewsTypeDto {
    totalCount: number | undefined;
    items: NewsTypeDto[] | undefined;
}

export class NewsTypeDto_Create implements INewsTypeDto_Create {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;

    constructor(data?: INewsTypeDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
        }
    }

    static fromJS(data: any): NewsTypeDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new NewsTypeDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data; 
    }

    clone(): NewsTypeDto_Create {
        const json = this.toJSON();
        let result = new NewsTypeDto_Create();
        result.init(json);
        return result;
    }
}

export interface INewsTypeDto_Create {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
}

export class NewsTypeDto_Update implements INewsTypeDto_Update {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;

    constructor(data?: INewsTypeDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
        }
    }

    static fromJS(data: any): NewsTypeDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new NewsTypeDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data; 
    }

    clone(): NewsTypeDto_Update {
        const json = this.toJSON();
        let result = new NewsTypeDto_Update();
        result.init(json);
        return result;
    }
}

export interface INewsTypeDto_Update {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
}

export class PagedResultDtoOfTreeItemDto implements IPagedResultDtoOfTreeItemDto {
    totalCount: number | undefined;
    items: TreeItemDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TreeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTreeItemDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTreeItemDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTreeItemDto {
    totalCount: number | undefined;
    items: TreeItemDto[] | undefined;
}

export class TreeItemDto implements ITreeItemDto {
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;

    constructor(data?: ITreeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.content = data["content"];
            this.treeId = data["treeId"];
            if (data["file"] && data["file"].constructor === Array) {
                this.file = [] as any;
                for (let item of data["file"])
                    this.file.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["treeId"] = this.treeId;
        if (this.file && this.file.constructor === Array) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreeItemDto {
        const json = this.toJSON();
        let result = new TreeItemDto();
        result.init(json);
        return result;
    }
}

export interface ITreeItemDto {
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;
}

export class File implements IFile {
    url: string | undefined;
    name: string | undefined;
    fileType: string | undefined;
    size: number | undefined;
    uploadTime: moment.Moment | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
            this.name = data["name"];
            this.fileType = data["fileType"];
            this.size = data["size"];
            this.uploadTime = data["uploadTime"] ? moment(data["uploadTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["size"] = this.size;
        data["uploadTime"] = this.uploadTime ? this.uploadTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): File {
        const json = this.toJSON();
        let result = new File();
        result.init(json);
        return result;
    }
}

export interface IFile {
    url: string | undefined;
    name: string | undefined;
    fileType: string | undefined;
    size: number | undefined;
    uploadTime: moment.Moment | undefined;
}

export class ListResultDtoOfTreeDto implements IListResultDtoOfTreeDto {
    items: TreeDto[] | undefined;

    constructor(data?: IListResultDtoOfTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfTreeDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfTreeDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfTreeDto {
    items: TreeDto[] | undefined;
}

export class TreeDto implements ITreeDto {
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;

    constructor(data?: ITreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCount = data["itemCount"];
            this.id = data["id"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): TreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCount"] = this.itemCount;
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        return data; 
    }

    clone(): TreeDto {
        const json = this.toJSON();
        let result = new TreeDto();
        result.init(json);
        return result;
    }
}

export interface ITreeDto {
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;
}

export class CreateTreeInput implements ICreateTreeInput {
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateTreeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateTreeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTreeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }

    clone(): CreateTreeInput {
        const json = this.toJSON();
        let result = new CreateTreeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateTreeInput {
    parentId: number | undefined;
    displayName: string;
}

export class UpdateTreeInput implements IUpdateTreeInput {
    id: number | undefined;
    displayName: string;

    constructor(data?: IUpdateTreeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateTreeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTreeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }

    clone(): UpdateTreeInput {
        const json = this.toJSON();
        let result = new UpdateTreeInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateTreeInput {
    id: number | undefined;
    displayName: string;
}

export class MoveTreeInput implements IMoveTreeInput {
    id: number | undefined;
    newParentId: number | undefined;

    constructor(data?: IMoveTreeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveTreeInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTreeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data; 
    }

    clone(): MoveTreeInput {
        const json = this.toJSON();
        let result = new MoveTreeInput();
        result.init(json);
        return result;
    }
}

export interface IMoveTreeInput {
    id: number | undefined;
    newParentId: number | undefined;
}

export class TreeDto_LoadAll implements ITreeDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: ITreeDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): TreeDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new TreeDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): TreeDto_LoadAll {
        const json = this.toJSON();
        let result = new TreeDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface ITreeDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfTreeDto_WithRelation implements IPagedResultDtoOfTreeDto_WithRelation {
    totalCount: number | undefined;
    items: TreeDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TreeDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTreeDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTreeDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTreeDto_WithRelation {
    totalCount: number | undefined;
    items: TreeDto_WithRelation[] | undefined;
}

export class TreeDto_WithRelation implements ITreeDto_WithRelation {
    children: TreeDto[] | undefined;
    parent: TreeDto | undefined;
    treeItems: TreeItemDto[] | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;

    constructor(data?: ITreeDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children.push(TreeDto.fromJS(item));
            }
            this.parent = data["parent"] ? TreeDto.fromJS(data["parent"]) : <any>undefined;
            if (data["treeItems"] && data["treeItems"].constructor === Array) {
                this.treeItems = [] as any;
                for (let item of data["treeItems"])
                    this.treeItems.push(TreeItemDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.itemCount = data["itemCount"];
            this.id = data["id"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): TreeDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new TreeDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (this.treeItems && this.treeItems.constructor === Array) {
            data["treeItems"] = [];
            for (let item of this.treeItems)
                data["treeItems"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["itemCount"] = this.itemCount;
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        return data; 
    }

    clone(): TreeDto_WithRelation {
        const json = this.toJSON();
        let result = new TreeDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface ITreeDto_WithRelation {
    children: TreeDto[] | undefined;
    parent: TreeDto | undefined;
    treeItems: TreeItemDto[] | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;
}

export class TreeDto_Create implements ITreeDto_Create {
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;

    constructor(data?: ITreeDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCount = data["itemCount"];
            this.id = data["id"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): TreeDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new TreeDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCount"] = this.itemCount;
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        return data; 
    }

    clone(): TreeDto_Create {
        const json = this.toJSON();
        let result = new TreeDto_Create();
        result.init(json);
        return result;
    }
}

export interface ITreeDto_Create {
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;
}

export class TreeDto_Update implements ITreeDto_Update {
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;

    constructor(data?: ITreeDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCount = data["itemCount"];
            this.id = data["id"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): TreeDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new TreeDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCount"] = this.itemCount;
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["parentId"] = this.parentId;
        return data; 
    }

    clone(): TreeDto_Update {
        const json = this.toJSON();
        let result = new TreeDto_Update();
        result.init(json);
        return result;
    }
}

export interface ITreeDto_Update {
    itemCount: number | undefined;
    id: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    parentId: number | undefined;
}

export class TreeItemDto_LoadAll implements ITreeItemDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: ITreeItemDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): TreeItemDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItemDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): TreeItemDto_LoadAll {
        const json = this.toJSON();
        let result = new TreeItemDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface ITreeItemDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfTreeItemDto_WithRelation implements IPagedResultDtoOfTreeItemDto_WithRelation {
    totalCount: number | undefined;
    items: TreeItemDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeItemDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TreeItemDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeItemDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeItemDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTreeItemDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTreeItemDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTreeItemDto_WithRelation {
    totalCount: number | undefined;
    items: TreeItemDto_WithRelation[] | undefined;
}

export class TreeItemDto_WithRelation implements ITreeItemDto_WithRelation {
    tree: TreeDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;

    constructor(data?: ITreeItemDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tree = data["tree"] ? TreeDto.fromJS(data["tree"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.content = data["content"];
            this.treeId = data["treeId"];
            if (data["file"] && data["file"].constructor === Array) {
                this.file = [] as any;
                for (let item of data["file"])
                    this.file.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeItemDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItemDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tree"] = this.tree ? this.tree.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["treeId"] = this.treeId;
        if (this.file && this.file.constructor === Array) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreeItemDto_WithRelation {
        const json = this.toJSON();
        let result = new TreeItemDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface ITreeItemDto_WithRelation {
    tree: TreeDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;
}

export class TreeItemDto_Create implements ITreeItemDto_Create {
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;

    constructor(data?: ITreeItemDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.content = data["content"];
            this.treeId = data["treeId"];
            if (data["file"] && data["file"].constructor === Array) {
                this.file = [] as any;
                for (let item of data["file"])
                    this.file.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeItemDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItemDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["treeId"] = this.treeId;
        if (this.file && this.file.constructor === Array) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreeItemDto_Create {
        const json = this.toJSON();
        let result = new TreeItemDto_Create();
        result.init(json);
        return result;
    }
}

export interface ITreeItemDto_Create {
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;
}

export class TreeItemDto_Update implements ITreeItemDto_Update {
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;

    constructor(data?: ITreeItemDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.content = data["content"];
            this.treeId = data["treeId"];
            if (data["file"] && data["file"].constructor === Array) {
                this.file = [] as any;
                for (let item of data["file"])
                    this.file.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeItemDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new TreeItemDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        data["treeId"] = this.treeId;
        if (this.file && this.file.constructor === Array) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TreeItemDto_Update {
        const json = this.toJSON();
        let result = new TreeItemDto_Update();
        result.init(json);
        return result;
    }
}

export interface ITreeItemDto_Update {
    creationTime: moment.Moment | undefined;
    id: number | undefined;
    displayName: string | undefined;
    content: string | undefined;
    treeId: number | undefined;
    file: File[] | undefined;
}

export class ActivityDto_ImageUploadDto implements IActivityDto_ImageUploadDto {
    id: number | undefined;
    schemaName: string | undefined;
    base64String: string | undefined;

    constructor(data?: IActivityDto_ImageUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.schemaName = data["schemaName"];
            this.base64String = data["base64String"];
        }
    }

    static fromJS(data: any): ActivityDto_ImageUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto_ImageUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["schemaName"] = this.schemaName;
        data["base64String"] = this.base64String;
        return data; 
    }

    clone(): ActivityDto_ImageUploadDto {
        const json = this.toJSON();
        let result = new ActivityDto_ImageUploadDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDto_ImageUploadDto {
    id: number | undefined;
    schemaName: string | undefined;
    base64String: string | undefined;
}

export class UserActivityDto_WithRelation implements IUserActivityDto_WithRelation {
    user: UserDto | undefined;
    activity: ActivityDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;

    constructor(data?: IUserActivityDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserDto.fromJS(data["user"]) : <any>undefined;
            this.activity = data["activity"] ? ActivityDto.fromJS(data["activity"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.activityId = data["activityId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UserActivityDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): UserActivityDto_WithRelation {
        const json = this.toJSON();
        let result = new UserActivityDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_WithRelation {
    user: UserDto | undefined;
    activity: ActivityDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    roleNames: string[] | undefined;
    id: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.emailAddress = data["emailAddress"];
            this.isActive = data["isActive"];
            this.fullName = data["fullName"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    roleNames: string[] | undefined;
    id: number | undefined;
}

export class UserActivityDto_CreateByIds implements IUserActivityDto_CreateByIds {
    userIds: number[] | undefined;
    activityId: number | undefined;

    constructor(data?: IUserActivityDto_CreateByIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [] as any;
                for (let item of data["userIds"])
                    this.userIds.push(item);
            }
            this.activityId = data["activityId"];
        }
    }

    static fromJS(data: any): UserActivityDto_CreateByIds {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_CreateByIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["activityId"] = this.activityId;
        return data; 
    }

    clone(): UserActivityDto_CreateByIds {
        const json = this.toJSON();
        let result = new UserActivityDto_CreateByIds();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_CreateByIds {
    userIds: number[] | undefined;
    activityId: number | undefined;
}

export class UserActivityDto_FindActivityUserInput implements IUserActivityDto_FindActivityUserInput {
    activityId: number | undefined;
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IUserActivityDto_FindActivityUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityId = data["activityId"];
            this.keyword = data["keyword"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): UserActivityDto_FindActivityUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_FindActivityUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): UserActivityDto_FindActivityUserInput {
        const json = this.toJSON();
        let result = new UserActivityDto_FindActivityUserInput();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_FindActivityUserInput {
    activityId: number | undefined;
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfUserDto implements IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;
}

export class UserActivityDto_LoadAllByUserId implements IUserActivityDto_LoadAllByUserId {
    userId: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IUserActivityDto_LoadAllByUserId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): UserActivityDto_LoadAllByUserId {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_LoadAllByUserId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): UserActivityDto_LoadAllByUserId {
        const json = this.toJSON();
        let result = new UserActivityDto_LoadAllByUserId();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_LoadAllByUserId {
    userId: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfUserActivityDto_WithRelation implements IPagedResultDtoOfUserActivityDto_WithRelation {
    totalCount: number | undefined;
    items: UserActivityDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfUserActivityDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(UserActivityDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserActivityDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserActivityDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserActivityDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserActivityDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserActivityDto_WithRelation {
    totalCount: number | undefined;
    items: UserActivityDto_WithRelation[] | undefined;
}

export class UserActivityDto_LoadAll implements IUserActivityDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IUserActivityDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): UserActivityDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): UserActivityDto_LoadAll {
        const json = this.toJSON();
        let result = new UserActivityDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class UserActivityDto_Create implements IUserActivityDto_Create {
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;

    constructor(data?: IUserActivityDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.activityId = data["activityId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UserActivityDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): UserActivityDto_Create {
        const json = this.toJSON();
        let result = new UserActivityDto_Create();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_Create {
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;
}

export class UserActivityDto_Update implements IUserActivityDto_Update {
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;

    constructor(data?: IUserActivityDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.activityId = data["activityId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UserActivityDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): UserActivityDto_Update {
        const json = this.toJSON();
        let result = new UserActivityDto_Update();
        result.init(json);
        return result;
    }
}

export interface IUserActivityDto_Update {
    id: number | undefined;
    activityId: number | undefined;
    userId: number | undefined;
}

export enum NewsDto_WithRelationDisplayMode {
    _0 = 0, 
    _1 = 1, 
}

export enum NewsDto_CreateDisplayMode {
    _0 = 0, 
    _1 = 1, 
}

export enum NewsDto_UpdateDisplayMode {
    _0 = 0, 
    _1 = 1, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}